import { AccountStatement } from '../elements/ExportsCards/AccountStatement'
import { AllData } from '../elements/ExportsCards/AllData'
import { Backup } from '../elements/ExportsCards/Backup'
import { BalanceList } from '../elements/ExportsCards/BalanceList'
import { ChartOfAccounts } from '../elements/ExportsCards/ChartOfAccounts'
import { Contacts } from '../elements/ExportsCards/Contacts'
import { CreditorList } from '../elements/ExportsCards/CreditorList'
import { CustomerAccountStatement } from '../elements/ExportsCards/CustomerAccountStatement'
import { DebtorList } from '../elements/ExportsCards/DebtorList'
import { EntryJournal } from '../elements/ExportsCards/EntryJournal'
import { FecReport } from '../elements/ExportsCards/FecReport'
import { Products } from '../elements/ExportsCards/Products'
import { VendorAccountStatement } from '../elements/ExportsCards/VendorAccountStatement'
import { XafExport } from '../elements/ExportsCards/XafExport'
import { ExportsCardId } from '../enums/exportsCardId'

export const exportCards = [
  { id: ExportsCardId.DebtorList, component: DebtorList },
  { id: ExportsCardId.CreditorList, component: CreditorList },
  { id: ExportsCardId.AccountStatement, component: AccountStatement },
  { id: ExportsCardId.EntryJournal, component: EntryJournal },
  { id: ExportsCardId.BalanceList, component: BalanceList },
  { id: ExportsCardId.ChartOfAccounts, component: ChartOfAccounts },
  { id: ExportsCardId.Contacts, component: Contacts },
  { id: ExportsCardId.Products, component: Products },
  { id: ExportsCardId.CustomerAccountStatement, component: CustomerAccountStatement },
  { id: ExportsCardId.VendorAccountStatement, component: VendorAccountStatement },
  { id: ExportsCardId.Backup, component: Backup },
  { id: ExportsCardId.FecReport, component: FecReport },
  { id: ExportsCardId.AllData, component: AllData },
  { id: ExportsCardId.XAF, component: XafExport },
]
